export default {
  screens: [
    {
      type: 'intro',
      title: '自然主義',
      content:
        '自然主義大自然豐富多姿且富有象徵意義，是取之不盡的靈感泉源，在品牌歷史上是一個重要的主題。',
      idYt: 'GUF98BCNd3c',
      videoCover: 'world/wild/video.jpg',
      desktop: {
        cover: 'world/wild/cover-1.jpg'
      },
      mobile: {
        cover: 'world/wild/mobile-cover-1.jpg',
        contentStyle: { width: '100%', paddingBottom: '120px' },
        coverStyle: {
          width: '110%',
          top: '87%',
          bottom: '40px',
          left: '0',
          position: 'absolute'
        }
      },
      isCover: true
    },
    {
      type: 'memento',
      img: 'world/wild/memento.jpg',
      content:
        ' 動物、植物和昆蟲經工匠們的巧手打造成珍寶，呈現大自然野性、活潑、優雅的風采。 <br><br> Chaumet的植物珠寶作品豐富多彩，構思獨具匠心。',
      cover: 'world/wild/cover-2.jpg',
      isCover: true
    },
    {
      type: 'staircase',
      desktop: {
        leftImg: 'world/wild/staircaseLeft.jpg',
        middleImg: 'world/wild/staircaseMiddle.jpg',
        rightImg: 'world/wild/staircaseRight.jpg',
        cover: 'world/wild/cover-3.jpg'
      },
      mobile: {
        leftImg: 'world/wild/staircaseLeft.jpg',
        middleImg: 'world/wild/staircaseMiddle.jpg',
        rightImg: 'world/wild/staircaseRight.jpg',
        cover: 'world/wild/mobile-cover-3.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: '85%',
          top: '-15%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      },
      content:
        '約瑟芬皇后最初選擇了輕風吹拂的麥穗，富饒的象徵。  <br><br> 自1811年的麥穗皇冠（Epis de Blé）開始，Chaumet在不同時期設計風格各異的麥穗珠寶。',
      isCover: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/cht/worlds/wild.js